import { render, staticRenderFns } from "./ljymWeb.vue?vue&type=template&id=f944f656&scoped=true&"
import script from "./ljymWeb.vue?vue&type=script&lang=js&"
export * from "./ljymWeb.vue?vue&type=script&lang=js&"
import style0 from "./ljymWeb.vue?vue&type=style&index=0&id=f944f656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f944f656",
  null
  
)

export default component.exports